
import { defineComponent } from 'vue'
import OutputBox from './Output.vue'
import InputBox from './InputBox.vue'
import Status from './Status.vue'
import Inventory from './Inventory.vue'
import TitleBar from './TitleBar.vue'

export default defineComponent({
  name: 'Screen',
  components: {
    InputBox,
    OutputBox,
    Status,
    TitleBar
  },
  props: {
    msg: String
  }
})
